module.exports = __webpack_public_path__ + "static/media/requestBetaAccess.dc734678.png";